import { useEffect } from 'react';
import { useNavigate } from '../../../shared/router/useNavigate';
import { useAuthStore } from './useAuthStore';

export const useRedirectIfNotAuthenticated = (redirectUrl: string) => {
	const navigate = useNavigate();
	const { isAuthenticated, isLoading } = useAuthStore();

	useEffect(() => {
		if (!isAuthenticated && !isLoading) {
			navigate(redirectUrl);
		}
	}, [isAuthenticated, isLoading]);
};
